import styled from 'styled-components';

// Adds element only visible to screen readers
export const SrOnly = styled.div`
  position: absolute;
  top: 0;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  pointer-events: none;
`;
